import { useEffect, useState } from "react";
import swal from 'sweetalert2';
import * as helper from "../global/helper";
import { updateMemberSubscriptionValidity } from "../api/usersAPI";

const EditUserSubscription = (props) => {
    const [memberDetails,                   setMemberDetails]         = useState({});

    useEffect(() => {
        $('#edit-Member-modal').modal({ backdrop: 'static' });
  
        $('#edit-Member-modal').on('hidden.bs.modal', function () {
          $('.modal').hasClass('show') && $('body').addClass('modal-open');   
          props.onDismissModal({}); 
        });
        $('#txtSubscriptionExpiresOn').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });
        $('#txtSubscriptionExpiresOn').on('change', function (event) {
            updateMemberDetails('SubscriptionExpiresOn',  moment(event.target.value, 'DD-MM-YYYY').format('YYYY-MM-DD'))
        });  
        $('#txtSubscriptionStartsFrom').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });
        $('#txtSubscriptionStartsFrom').on('change', function (event) {
            updateMemberDetails('SubscriptionStartsFrom',  moment(event.target.value, 'DD-MM-YYYY').format('YYYY-MM-DD'))
        });  
    }, []);

    useEffect(() => {
        if(props.memberDetails){
            setMemberDetails(props.memberDetails);
        }; 
     },[props.memberDetails]);
  
    const updateMemberDetails = (field, value) => { 
        setMemberDetails((d) => {
            return { ...d, [field]: value };
        });
    };

    const updateMemberHandler = async() => {
        const btn = $('#btnPay');
        var form = $('#updateMember');

        form.validate({
            rules: {            
                txtSubscriptionStartsFrom: {
                    required: true,
                },         
                txtSubscriptionExpiresOn: {
                    required: true,
                }         
            },
            messages: { 
                txtSubscriptionStartsFrom: {
                    required: "Please select subscription starts from"
                },
                txtSubscriptionExpiresOn: {
                    required: "Please select subscription expires On"
                } 
            }
        });

        if (!form.valid()) return;
        
        helper.StartProcessing(btn);
        try {
            if((moment(memberDetails.SubscriptionStartsFrom).isAfter(memberDetails.SubscriptionExpiresOn))){
                swal.fire({
                    icon                  : 'warning',
                    titleText             : 'Date Conflict!',
                    buttonsStyling        : false,  
                    confirmButtonClass    : 'btn btn-brand',   
                });
                helper.StopProcessing(btn);
                return  
            };
            await updateMemberSubscriptionValidity({SubscriptionValidityID: memberDetails.SubscriptionValidityID, SubscriptionStartsFrom: memberDetails.SubscriptionStartsFrom, SubscriptionExpiresOn: memberDetails.SubscriptionExpiresOn});
            helper.StopProcessing(btn);
            
            setMemberDetails({})
            
            swal.fire({
                toast: true,
                icon: 'success',
                titleText: 'Subscription updated successfully!',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 1500,
                animation: false,
                customClass: {
                    popup: 'margin-20',
                },
            });
            $('#edit-Member-modal').modal('hide');
            props.refetchReport();

        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            return;
        }
    };

    return(
        <>
            <div className="modal fade"id="edit-Member-modal"tabIndex="-1"role="dialog"aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Edit Subscription</h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                            </button>
                        </div>
                        <div className="modal-body">
                            <form className="kt-form sticky margin-b10 padding-t15 padding-b10 bg-white" id="updateMember" >                
                                <div id="ControlHolder" className="kt-form kt-form--label-right bv-form" role="form">
                                    <div className="row">

                                        <div className="col-6 form-group">
                                            <label>Subscription Starts From</label>
                                            <div className="input-group date">
                                                <input 
                                                    id="txtSubscriptionStartsFrom" 
                                                    name="txtSubscriptionStartsFrom" 
                                                    type="text" 
                                                    placeholder="Select starts from"
                                                    className="form-control date-input" 
                                                    readOnly={true} 
                                                    value={memberDetails.SubscriptionStartsFrom ? moment(memberDetails.SubscriptionStartsFrom).format('DD-MM-YYYY') : ''} 
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">
                                                        <i className="la la-calendar-check-o"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6 form-group">
                                            <label>Subscription Expires On</label>
                                            <div className="input-group date">
                                                <input 
                                                    id="txtSubscriptionExpiresOn" 
                                                    name="txtSubscriptionExpiresOn" 
                                                    type="text" 
                                                    placeholder="Select expires on"
                                                    className="form-control date-input" 
                                                    readOnly={true} 
                                                    value={memberDetails.SubscriptionExpiresOn ? moment(memberDetails.SubscriptionExpiresOn).format('DD-MM-YYYY') : ''} 
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">
                                                        <i className="la la-calendar-check-o"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary margin-0 margin-r5"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                id="btnPay"
                                onClick={updateMemberHandler}
                                type="button"
                                className={`btn btn-success margin-0 `}
                            >                  
                               Update Subscription 
                            </button>
                            
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditUserSubscription;

